import React from "react";
import { Stack, Typography, Button, Link } from "@mui/material";
import TextInput from "../inputs/TextField";
import { useFormik } from "formik";
import * as Yup from "yup";

export interface RecoverPasswordFormInterface {
  initialData: { email: "" };
  handleAction: (type: string, data: any) => void;
}
const SCHEMA = {
  email: Yup.string().email().required("Please enter your email."),
};
const RecoverPasswordForm = ({
  initialData,
  handleAction,
}: RecoverPasswordFormInterface) => {
  const { values, handleChange, handleBlur, handleSubmit, touched, errors } =
    useFormik({
      initialValues: initialData,
      validationSchema: Yup.object(SCHEMA),
      onSubmit: (value) => handleAction("submit", value),
    });
  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", height: "100%" }}>
      <Stack
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        height="100%"
      >
        <Stack padding={2} spacing={3} textAlign="center">
          <Typography variant="h1" fontWeight={700}>
            Recover your password
          </Typography>
          <Typography variant="h4" fontWeight={400}>
            Enter your email and we will send you instructions to generate a new
            password.
          </Typography>
        </Stack>

        <TextInput
          label="Email"
          name="email"
          id="email"
          placeholder="Email"
          helperText={touched.email ? errors.email : ""}
          error={touched.email && Boolean(errors.email)}
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
        />

        <Stack
          spacing={3}
          width="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onSubmit={() => handleSubmit()}
          >
            Send Instructions
          </Button>
          <Link color="primary">Back to Sign in</Link>
        </Stack>
      </Stack>
    </form>
  );
};
export default RecoverPasswordForm;
